module.exports = __webpack_public_path__ + "img/map-poster.f64dfb25.png";